import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ShowXResults } from 'autogen/translation-keys/trans-website-filter';
import { Button } from 'components/Button';
import useClearAllSmartviews from 'components/generic/smartview/shared/hooks/useClearAllSmartviews';
import { format } from 'modules/helpers/strings';
import useFilters from '../../../shared/hooks/useFilters';
import { FilterMenuDataContext } from '../../Filters/FilterMenuRenderer';

export default function ApplyFiltersButton() {
    const { t } = useTranslation();
    const { applyPendingFilters } = useFilters();
    const close = useClearAllSmartviews();

    const {
        productList: {
            pagingModel: { hitsTotal }
        }
    } = useContext(FilterMenuDataContext);

    const handleApplyFilters = () => {
        applyPendingFilters();
        close();
    };

    return (
        <Button size="lg" onClick={handleApplyFilters} disabled={hitsTotal === 0}>
            {format(t(ShowXResults))(hitsTotal)}
        </Button>
    );
}
